import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import ContentCard from "../Common/Layout/ContentCard";
import LoginForm from "./LoginForm";

const Login = () => {
  return (
    <>
      <Flex h="100vh" alignItems="center" justifyContent="center">
        <ContentCard w={["auto", "30%"]}>
          <Box p="3">Bienvenido</Box>
          <LoginForm></LoginForm>
        </ContentCard>
      </Flex>
    </>
  );
};

export default Login;
